import { Navigate } from "react-router-dom";
import { PageContainer, PageHeader } from "@/components/PagePrimitives";
import { AreaAccountingSettings } from "@/components/AreaAccountingSettings";
import { useModules } from "@/auth/ModulesContext";

const COPY = {
  ar: {
    eyebrow: "Receivables",
    subtitle: "How issued invoices, their payments, credit notes and voids post to your books.",
    module: "ar.accounting",
    home: "/ar",
  },
  ap: {
    eyebrow: "Payables",
    subtitle: "How approved bills, their payments and supplier credit post to your books.",
    module: "ap.accounting",
    home: "/ap",
  },
} as const;

export function AreaAccountingPage({ area }: { area: "ar" | "ap" }) {
  const { hasModule } = useModules();
  const copy = COPY[area];

  // Without the module, a deep link goes home rather than to a page of 403s.
  if (!hasModule(copy.module)) {
    return <Navigate to={copy.home} replace />;
  }

  return (
    <PageContainer size="narrow">
      <PageHeader eyebrow={copy.eyebrow} title="Accounting" subtitle={copy.subtitle} />
      <AreaAccountingSettings area={area} />
    </PageContainer>
  );
}
